import { Button, H6 } from "@sellar-io/components";
import React from "react";

import { useSpotlightFilterStore } from "../SpotlightFilterStore";
import { SpotlightContainer } from "../../../../spotlight/SpotlightFilterStore";

interface FilterContainerCardProps {
  onClick?: () => void;
}

const spotlightContainerTypes = [
  "keg",
  "cask",
  "can",
  "bottle",
  "bagInBox",
] as const;

export default function FilterContainerCard({
  onClick,
}: FilterContainerCardProps) {
  const selectedContainerTypes = useSpotlightFilterStore(
    (state) => state.selectedContainerTypes,
  );
  const toggleContainerType = useSpotlightFilterStore(
    (state) => state.toggleContainerType,
  );

  const handleToggle = (type: SpotlightContainer) => {
    toggleContainerType(type);
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="rounded-sm bg-white p-4">
      <div className="flex flex-wrap items-center gap-2">
        <H6>Filter by:</H6>
        {spotlightContainerTypes.map((containerType) => {
          const isSelected = selectedContainerTypes.includes(containerType);
          return (
            <Button
              color="slim"
              size="small"
              key={containerType}
              onClick={() => handleToggle(containerType)}
              selected={isSelected}
              aria-pressed={isSelected}
              className="capitalize shadow-xs"
              aria-label={`Filter by ${containerType}`}
            >
              {containerType === "bagInBox"
                ? "Bag In Box"
                : containerType.charAt(0).toUpperCase() +
                  containerType.slice(1)}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
